import { DivIcon, PointExpression } from "leaflet";
import { Fragment, useCallback } from "react";
import { renderToString } from "react-dom/server";
import { Marker, Polygon, Polyline } from "react-leaflet";
import { useDispatch, useSelector } from "react-redux";

import { VehiclePointType } from "constant";
import features from "features";
import { RootStateInterface } from "reducer";
import { MissionsManagerStateInterface } from "scenes/MissionsManager/interfaces";

import MapPointIcon from "../MapPointIcon/MapPointIcon";
import MapVehicleMarkerIcon from "../MapVehicleMarkerIcon/MapVehicleMarkerIcon";

function getRandomColor() {
  const hue = Math.floor(Math.random() * 360);
  const saturation = 70;
  const lightness = 50;
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

const getMarkerIcon = (isInPoint, index) => {
  const iconSize: PointExpression = isInPoint ? [52, 110] : [52, 52];
  const iconAnchor: PointExpression = [26, 26];

  return new DivIcon({
    html: renderToString(
      <MapVehicleMarkerIcon isInPoint={isInPoint} index={index} />
    ),
    className: "marker-reset",
    iconSize,
    iconAnchor
  });
};
const getPolygonFlagIcon = () => {
  const iconSize: PointExpression = [25, 30];
  const iconAnchor: PointExpression = [0, 30];

  return new DivIcon({
    html: renderToString(<MapPointIcon />),
    className: "marker-reset",
    iconSize,
    iconAnchor
  });
};

const MapMissionItems = () => {
  const dispatch = useDispatch();

  const { mission, vehicle: activeVehicle } = useSelector<
    RootStateInterface,
    MissionsManagerStateInterface
  >((state) => state.missionsManager);

  const onActivateVehicleEdit = useCallback(
    (index) => () => {
      const t = document.getElementById(`vehicle-${index}`);
      t.click();
    },
    []
  );
  const onChangeVehiclePosition = useCallback(
    (poinType: VehiclePointType) => (e) => {
      dispatch(features.missionsManager.actions.awaitVehiclePosition(poinType));
      const { lat, lng } = e.target.getLatLng();

      dispatch(
        features.missionsManager.actions.setVehiclePosition({
          coordinates: [lat, lng],
          type: "Point"
        })
      );
    },
    [dispatch]
  );

  return (
    <>
      {mission?.data?.routes?.map(
        (route, i) =>
          route?.coordinates && (
            <Polyline
              positions={route?.coordinates}
              color={getRandomColor()}
              key={`route-${i}`}
            />
          )
      )}
      {mission?.data?.vehicles?.map((vehicle, index) => {
        const editPoint = index === activeVehicle?.vehicleIndex;
        return (
          <Fragment key={`vehicle-${index}`}>
            <Marker
              draggable={editPoint}
              position={
                (editPoint ? activeVehicle : vehicle).in_point.coordinates
              }
              icon={getMarkerIcon(true, index + 1)}
              key={`marker-vehicle-${index}-in`}
              opacity={editPoint ? 0.8 : 1}
              eventHandlers={{
                click: onActivateVehicleEdit(index),
                dragend: onChangeVehiclePosition(VehiclePointType.ENTER)
              }}
            />
            <Marker
              draggable={editPoint}
              position={
                (editPoint ? activeVehicle : vehicle).out_point.coordinates
              }
              icon={getMarkerIcon(false, index + 1)}
              key={`marker-vehicle-${index}-out`}
              opacity={editPoint ? 0.8 : 1}
              eventHandlers={{
                click: onActivateVehicleEdit(index),
                dragend: onChangeVehiclePosition(VehiclePointType.EXIT)
              }}
            />
          </Fragment>
        );
      })}
      {mission?.data?.polygon?.coordinates[0].map((item, i) => (
        <Marker
          position={item}
          icon={getPolygonFlagIcon()}
          key={`mission-cordon-point-${i}`}
        />
      ))}
      {mission?.data?.polygon && (
        <Polygon
          positions={mission?.data.polygon.coordinates}
          color={"#00CB50"}
          fillColor={"#00CB50"}
          weight={5}
        />
      )}
    </>
  );
};

export default MapMissionItems;
